import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addBettingSelection } from "@/api/bettingSelections";
import { BettingSelectionsQueryKeys } from "@/tanstackQuery/queries/bettingSelections";
import { AddBettingSelectionParams } from "@/types/ApiResponses/BettingSelection";

export const useAddBettingSelection = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: AddBettingSelectionParams) => addBettingSelection(params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [BettingSelectionsQueryKeys.BettingSelections] });
    },
  });
};
